// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"logo_ko-KR__45MCx","impressionTrackingContainer":"logo_impressionTrackingContainer__Av3XJ","logo":"logo_logo__3IDUg","logo__image":"logo_logo__image__LXpja"};